import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from "@angular/core";
import { DashboardStateService } from "@app/services/dashboard-state.service";
import { RejectedOrder } from "@app/models/dashboard.models";
import { staggerSlideIn } from "@app/animations/stagger-entrance.animation";

const DISPLAY_LIMIT = 6;

@Component({
  selector: "app-rejected-knitting-orders",
  templateUrl: "./rejected-knitting-orders.component.html",
  styleUrl: "./rejected-knitting-orders.component.scss",
  animations: [staggerSlideIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RejectedKnittingOrdersComponent {
  private readonly stateService = inject(DashboardStateService);

  readonly orders = computed<RejectedOrder[]>(
    () =>
      this.stateService.lastData()?.rejectedOrders?.slice(0, DISPLAY_LIMIT) ??
      [],
  );

  readonly animationTrigger = computed(() => this.orders());

  getPassedRate(order: RejectedOrder): number {
    return 100 - order.rejectionRate;
  }
}
